<template>
  <div class="kanban-card">
    <div class="kanban-card--title" @click="openDetail(task._id)">{{ task.name | translate }}</div>
    <div class="kanban-card--text" @click="openDetail(task._id)">{{ task.description | translate }}</div>
    <span class="mb-2" @click="openDetail(task._id)" v-b-tooltip.hover :title="task.organization.name">
      <!-- <letter-avatar :summarize="true" :name="task.organization.name" :showName="true" size="xxs" :image="task.organization.logo" variant="secondary" /> -->
      <i class="bx bxs-school align-middle"></i>
      {{ task.organization.name | summary }}
    </span>

    <div class="d-flex justify-content-between">
      <div class="d-flex align-items-center">
        <div class="kanban-card--no">#{{ task.no }}</div>
        <div class="kanban-card--comments">
          <task-priority :priority="task.priority" size="13" :onlyIcon="true" />
          <span class="mb-4 " v-for="product in task.products" @click="openDetail(task._id)" :key="task._id + product">
            <product :onlyIcon="true" :product="product"></product>
          </span>
        </div>
      </div>
      <div class="d-flex align-items-between" style="gap: 0.5rem;">
        <task-avatar :account="task.assignee" />

        <!-- <letter-avatar :name="'task.organization.name'" :image="task.organization.logo" variant="secondary" />
        <i class="iconoir-chat-bubble-question" style="color: #FF7C48; font-size: 1rem;"></i>
        <i class="iconoir-shield-alert" style="color: #FF7C48; font-size: 1rem;"></i>
        <i class="iconoir-shield-check" style="color: #FF7C48; font-size: 1rem;"></i>
         -->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["task"],
  mounted() {
    const id = this.$route.params.id;

    if (id && this.$route.path.includes("task")) {
      this.openDetail(id);
    }
  },
  methods: {
    openDetail(id) {
      if (this.$store.getters["task/showTaskDetailModal"]) return; //bir sürü istek gitmesini engellemek icin

      this.$store.commit("task/showTaskDetailModal", true);
      this.$store.dispatch("task/fetchDetail", id);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../../modules/task/tasks.scss";
</style>
